import React from 'react';

const { useEffect, useState } = React;

export const useMousePosition = () => {
    const [documentLeft, setDocumentLeft] = useState(false);

    useEffect(() => {
        // TODO detect mobile devices and only do this on desktops
        const handleEnter = () => setDocumentLeft(true);
        const handleLeave = () => setDocumentLeft(false);
        document.addEventListener('mouseleave', handleEnter);
        document.addEventListener('mouseenter', handleLeave);

        return () => {
            document.removeEventListener('mouseleave', handleEnter);
            document.removeEventListener('mouseenter', handleLeave);
        };
    });
    return {
        documentLeft,
    };
};
